module.exports = __webpack_public_path__ + "static/media/Circular Std Book.860c3ec7.ttf";